// extracted by mini-css-extract-plugin
export default {"btn":"Details_btn__-OMv7","iconBtn":"Details_iconBtn__FYrbP","listBtn":"Details_listBtn__QKhnY","pl":"Details_pl__4UTe-"};